module.exports = __webpack_public_path__ + "assets/img/two-tab9-on.ceb76ff1.png";